const validationMessages = {
  presence: () => t('validationMessages.presence', { ns: i18next.Namespace.COMMON }),
  email: () => t('validationMessages.email', { ns: i18next.Namespace.COMMON }),
  numericality: {
    greaterThan: (value) => t('validationMessages.greaterThan', { value, ns: i18next.Namespace.COMMON }),
    greaterThanOrEqualTo: (value) => t('validationMessages.greaterThanOrEqualTo', { value, ns: i18next.Namespace.COMMON }),
    cannotBeNegativeNumber: (value) => t('validationMessages.cannotBeNegativeNumber', { value, ns: i18next.Namespace.COMMON }),
  },
  length: (min, max) => t('validationMessages.length', { min, max, ns: i18next.Namespace.COMMON }),
  maxLength: (max) => t('validationMessages.maxLength', { max, ns: i18next.Namespace.COMMON }),
  phone: () => t('validationMessages.phone', { ns: i18next.Namespace.COMMON }),
  inclusion: () => t('validationMessages.inclusion', { ns: i18next.Namespace.COMMON }),
  link: () => t('validationMessages.link', { ns: i18next.Namespace.COMMON }),
  photos: {
    lessThanOrEqualTo: (value) => t('validationMessages.photosLessThanOrEqualTo', { value, ns: i18next.Namespace.COMMON }),
  },
  hubspotId: {
    lessThanOrEqualTo: (value) => t('validationMessages.hubspotIdLessThanOrEqualTo', { value, ns: i18next.Namespace.COMMON }),
  },
  selectProjectType: () => t('validationMessages.selectProjectType', { ns: i18next.Namespace.COMMON }),
};

export default validationMessages;
